<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  @if (isLoading) {
    <div class="formLoader">
      <i class="fa fa-spinner fa-spin gt-refresh"></i>
    </div>
  } @else {
    <div class="panel panel-default">
      <div class="panel-body">
        <form [formGroup]="refreshForm" (ngSubmit)="isCreateMode ? save() : update()">

          @if (isCreateMode) {
            <div class="row">
              <div class="col-md-4">
                <ng-container [ngTemplateOutlet]="taxYearField"></ng-container>
              </div>
              <div class="col-md-4">
                <ng-container [ngTemplateOutlet]="scenarioTypeCodeField"></ng-container>
              </div>
              <div class="col-md-4">
                <ng-container [ngTemplateOutlet]="scenarioDescField"></ng-container>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <ng-container [ngTemplateOutlet]="groupObjYearField"></ng-container>
              </div>
              <div class="col-md-4">
                <ng-container [ngTemplateOutlet]="batchStartDateField"></ng-container>
              </div>
              <div class="col-md-4">
                <ng-container [ngTemplateOutlet]="batchEndDateField"></ng-container>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <ng-container [ngTemplateOutlet]="defaultTaxYearBeginField"></ng-container>
              </div>
              <div class="col-md-6">
                <ng-container [ngTemplateOutlet]="defaultTaxYearEndField"></ng-container>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <ng-container [ngTemplateOutlet]="refreshStatusField"></ng-container>
              </div>
              <div class="col-md-6">
                <ng-container [ngTemplateOutlet]="defaultFilingCycleField"></ng-container>
              </div>
            </div>
          } @else {
            <div class="row">
              <div class="col-md-6">
                <ng-container [ngTemplateOutlet]="taxYearField"></ng-container>
              </div>
              <div class="col-md-6">
                <ng-container [ngTemplateOutlet]="groupObjYearField"></ng-container>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <ng-container [ngTemplateOutlet]="batchStartDateField"></ng-container>
              </div>
              <div class="col-md-4">
                <ng-container [ngTemplateOutlet]="batchEndDateField"></ng-container>
              </div>
              <div class="col-md-4">
                <ng-container [ngTemplateOutlet]="refreshStatusField"></ng-container>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <ng-container [ngTemplateOutlet]="defaultTaxYearBeginField"></ng-container>
              </div>
              <div class="col-md-4">
                <ng-container [ngTemplateOutlet]="defaultTaxYearEndField"></ng-container>
              </div>
              <div class="col-md-4">
                <ng-container [ngTemplateOutlet]="defaultFilingCycleField"></ng-container>
              </div>
            </div>
          }

          <ng-template #taxYearField>
            <div class="form-group">
              <label for="tax-year"><b>Tax Year<sup>*</sup>:</b></label>
              <input
                type="text"
                class="form-control"
                id="tax-year"
                formControlName="TAX_YEAR"
                readonly>
              @if (refreshForm.get('TAX_YEAR')?.invalid && refreshForm.get('TAX_YEAR')?.touched) {
                <small class="text-danger">Please provide Tax Year</small>
              }
            </div>
          </ng-template>

          <ng-template #scenarioTypeCodeField>
            <div class="form-group">
              <label for="scenario-type-code"><b>Scenario Type Code<sup>*</sup>:</b></label>
              <select
                class="form-control"
                id="scenario-type-code"
                formControlName="SCENARIO_TYPE_CODE"
                (change)="onScenarioTypeCodeChange()">
                <option value="">Select Scenario Type Code</option>
                @for (scenario of allScenarioTypeCode; track $index) {
                  <option [value]="scenario.SCENARIO_TYPE_CODE">{{ scenario.SCENARIO_TYPE_CODE }}</option>
                }
              </select>
              @if (refreshForm.get('SCENARIO_TYPE_CODE')?.invalid && refreshForm.get('SCENARIO_TYPE_CODE')?.touched) {
                <small class="text-danger">Please provide Scenario Type Code</small>
              }
            </div>
          </ng-template>

          <ng-template #scenarioDescField>
            <div class="form-group">
              <label for="scenario-desc"><b>Scenario Desc<sup>*</sup>:</b></label>
              <select
                class="form-control"
                id="scenario-desc"
                formControlName="SCENARIO_DESC"
                (change)="onScenarioDescChange()">
                <option value="">Select Scenario Description</option>
                @for (scenario of allScenarioDesc; track $index) {
                  <option [value]="scenario.SCENARIO_VALUE">{{ scenario.SCENARIO_DESC }}</option>
                }
              </select>
              @if (refreshForm.get('SCENARIO_DESC')?.invalid && refreshForm.get('SCENARIO_DESC')?.touched) {
                <small class="text-danger">Please provide Scenario Desc</small>
              }
            </div>
          </ng-template>

          <ng-template #groupObjYearField>
            <div class="form-group">
              <label for="group-obj-key"><b>Group Object Year<sup>*</sup>:</b></label>
              @if (isCreateMode) {
                <select
                  class="form-control"
                  id="group-obj-key"
                  formControlName="GROUP_OBJ_KEY">
                  <option value="">Select Group Object Year</option>
                  @for (groupObj of allGroupObjByYear; track $index) {
                    <option [value]="groupObj.GROUP_OBJ_KEY">{{ groupObj.GROUP_OBJ_KEY }}</option>
                  }
                </select>
              } @else {
                <input
                  type="text"
                  class="form-control"
                  id="group-obj-key"
                  formControlName="GROUP_OBJ_KEY"
                  readonly>
              }
              @if (refreshForm.get('GROUP_OBJ_KEY')?.invalid && refreshForm.get('GROUP_OBJ_KEY')?.touched) {
                <small class="text-danger">Please provide Group Object Year</small>
              }
            </div>
          </ng-template>

          <ng-template #batchStartDateField>
            <div class="form-group">
              <label for="batch-start-date"><b>Batch Start Date<sup>*</sup>:</b></label>
              <input
                type="date"
                class="form-control"
                id="batch-start-date"
                formControlName="BATCH_START_DATE"
                [min]="minYear"
                [max]="maxYear"
                (change)="onBatchStartDateChange()">
              @if (refreshForm.get('BATCH_START_DATE')?.invalid && refreshForm.get('BATCH_START_DATE')?.touched) {
                <small class="text-danger">Please provide Batch Start Date</small>
              }
            </div>
          </ng-template>

          <ng-template #batchEndDateField>
            <div class="form-group">
              <label for="batch-end-date"><b>Batch End Date:</b></label>
              <input
                type="date"
                class="form-control"
                id="batch-end-date"
                formControlName="BATCH_END_DATE"
                [min]="minYear"
                [max]="maxYear"
                (change)="onBatchEndDateChange()">
              @if (refreshForm.get('BATCH_END_DATE')?.invalid && refreshForm.get('BATCH_END_DATE')?.touched) {
                <small class="text-danger">Please provide Batch End Date</small>
              }
            </div>
          </ng-template>

          <ng-template #defaultTaxYearBeginField>
            <div class="form-group">
              <label for="default-tax-year-begin"><b>Default Tax Year Begin<sup>*</sup>:</b></label>
              <input
                type="date"
                class="form-control"
                id="default-tax-year-begin"
                formControlName="DEFAULT_TAX_YEAR_BEGIN"
                [min]="minYear"
                [max]="maxYear">
              @if (refreshForm.get('DEFAULT_TAX_YEAR_BEGIN')?.invalid && refreshForm.get('DEFAULT_TAX_YEAR_BEGIN')?.touched) {
                <small class="text-danger">Please provide Default Tax Year Begin Date</small>
              }
            </div>
          </ng-template>

          <ng-template #defaultTaxYearEndField>
            <div class="form-group">
              <label for="default-tax-year-end"><b>Default Tax Year End<sup>*</sup>:</b></label>
              <input
                type="date"
                class="form-control"
                id="default-tax-year-end"
                formControlName="DEFAULT_TAX_YEAR_END"
                [min]="minYear"
                [max]="maxYear">
              @if (refreshForm.get('DEFAULT_TAX_YEAR_END')?.invalid && refreshForm.get('DEFAULT_TAX_YEAR_END')?.touched) {
                <small class="text-danger">Please provide Default Tax Year End Date</small>
              }
            </div>
          </ng-template>

          <ng-template #refreshStatusField>
            <div class="form-group">
              <label for="refresh-status"><b>Refresh Status<sup>*</sup>:</b></label>
              <select
                class="form-control"
                id="refresh-status"
                formControlName="REFRESH_STATUS">
                <option value="0">0</option>
                <option value="40">40</option>
              </select>
              @if (refreshForm.get('REFRESH_STATUS')?.invalid && refreshForm.get('REFRESH_STATUS')?.touched) {
                <small class="text-danger">Please provide Refresh Status</small>
              }
            </div>
          </ng-template>

          <ng-template #defaultFilingCycleField>
            <div class="form-group">
              <label for="default-filing-cycle"><b>Default Filing Cycle<sup>*</sup>:</b></label>
              <select
                class="form-control"
                id="default-filing-cycle"
                formControlName="DEFAULT_FILING_CYCLE">
                <option value="">Select Filing Cycle</option>
                <option value="CYE">CYE</option>
                <option value="FYE">FYE</option>
                <option value="FIXED">FIXED</option>
              </select>
              @if (refreshForm.get('DEFAULT_FILING_CYCLE')?.invalid && refreshForm.get('DEFAULT_FILING_CYCLE')?.touched) {
                <small class="text-danger">Please provide Default Filing Cycle</small>
              }
            </div>
          </ng-template>

        </form>
      </div>
    </div>
  }
</div>

<div class="modal-footer" [hidden]="minimise">
  @if (isCreateMode) {
    <button class="create-button"
            type="button"
            (click)="save()"
            [disabled]="isSaving">
      @if (isSaving) {
        <span><i class="fa fa-spinner fa-pulse"></i></span>
      }
      Create
    </button>

    <button class="reset-button"
            type="button"
            (click)="reset()">
      Reset
    </button>

    <button class="cancel-button"
            type="button"
            (click)="cancel()">
      Cancel
    </button>
  } @else {
    <button class="update-button"
            type="button"
            (click)="update()"
            [disabled]="isSavingUpdate">
      @if (isSavingUpdate) {
        <span><i class="fa fa-spinner fa-pulse"></i></span>
      }
      Update
    </button>

    <button class="reset-button"
            type="button"
            (click)="reset()">
      Reset
    </button>

    <button class="cancel-button"
            type="button"
            (click)="cancel()">
      Cancel
    </button>

    <button class="delete-button"
            type="button"
            (click)="delete()"
            [disabled]="isSavingDelete">
      @if (isSavingDelete) {
        <span><i class="fa fa-spinner fa-pulse"></i></span>
      }
      Delete
    </button>
  }
</div>
